import './employees.scss';
import Swiper from 'swiper';
import { Scrollbar, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { initSwiperSlider } from '@/js/modules/swiper-slider.js';

document.addEventListener( 'DOMContentLoaded', function() {
	initSwiperSlider( '.o-employees .js-swiperSlider' );
} );

document.addEventListener( 'DOMContentLoaded', function() {

	const sliders = document.querySelectorAll( '.js-employeeSlider' );

	sliders.forEach( function( slider ) {

		const scrollbar = slider.querySelector( '.swiper-scrollbar' );
		const nextEl = slider.querySelector( '.o-employees__arrow-next' );
		const prevEl = slider.querySelector( '.o-employees__arrow-prev' );

		// Initialize Swiper
		const swiperInstance = new Swiper( slider, {
			modules: [ Scrollbar, Navigation ],
			slidesPerView: 1,
			spaceBetween: 32,
			grabCursor: true,
			scrollbar: {
				el: scrollbar,
				draggable: true,
				dragSize: 'auto',
			},
			navigation: nextEl && prevEl ? {
				nextEl: nextEl,
				prevEl: prevEl,
			} : false,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		} );

	} );

} );